import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../login/logo.png';
import './LoginForm.css';

const ForgotPasswordForm = () => (
  <div className="login-container">
    <div>
      <img src={logo} alt="App Logo" className="login-logo" />
    </div>
    <div className="login-form">
      <h5 className="text-center mb-3 login-welcome">Forgot password?</h5>
      <p className="text-center forgot-password-help">
        If you do not remember your password, please contact management to reset it.
      </p>
      <div className="forgot-password-container">
        <Link to="/login" className="forgot-password-link">
          Back to login
        </Link>
      </div>
    </div>
  </div>
);

export default ForgotPasswordForm;
